var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('notifications',{attrs:{"position":"bottom left"}}),_c('LoginDialog'),_c('LoadingDialog'),_c('MessageDialog'),_c('NewNavbar'),_vm._t("default"),_c('NewFooter')],2)}
var staticRenderFns = []

export { render, staticRenderFns }